
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultants/[slug]",
      function () {
        return require("private-next-pages/consultants/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultants/[slug]"])
      });
    }
  